import { Component, OnInit } from "@angular/core";
import { ButtonAction } from "../../shared/button/button-action.model";

@Component({
  selector: "toolbox-buttons",
  templateUrl: "./buttons.component.html",
  styleUrls: ["./buttons.component.scss"],
})
export class ButtonsComponent implements OnInit {
  splitButtonOptions: ButtonAction[] = [];

  constructor() { }

  ngOnInit() {
    this.splitButtonOptions = [
      new ButtonAction({
        name: "Split Button Option 1",
        action: () => console.log("Split Button Option 1"),
      }),
      new ButtonAction({
        name: "Split Button Option 2",
        action: () => console.log("Split Button Option 2"),
      }),
    ];
  }


  submit(event) {
    console.log("SUBMIT", event);
  }
}
